import React from 'react'
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Input,
  Form,
  FormGroup,
  Label
} from 'reactstrap'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const ReportModal = React.memo(
  ({ isOpen, toggle, className, onSubmit, storeName }) => {
    let textInput = null
    return (
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        className={`${className} report-modal`}
        size='lg'
      >
        <Form name='contact'>
          <ModalHeader toggle={toggle}>
            <FormattedMessage id='store.actions.report.report' />{' '}
            <span className='font-weight-normal'>{storeName}</span>
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                <FormattedMessage id='store.actions.report.provideReason' />
              </Label>
              <FormattedMessage id='reportModal.message'>
                {msg => (
                  <Input
                    rows='4'
                    type='textarea'
                    name='message'
                    id='message'
                    placeholder={msg}
                    innerRef={input => {
                      textInput = input
                    }}
                    required
                  />
                )}
              </FormattedMessage>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              color='black'
              className='order-1 order-md-0'
              outline
              onClick={toggle}
            >
              <FormattedMessage id='general.modalClose' />
            </Button>{' '}
            <Button
              color='primary'
              className='order-0 order-md-1 mb-3 mb-md-0'
              onClick={e => onSubmit(textInput.value)}
            >
              <FormattedMessage id='store.actions.report.sendReport' />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    )
  }
)

ReportModal.displayName = 'ReportModal'

ReportModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  storeName: PropTypes.string
}

export default ReportModal
